import { render, staticRenderFns } from "./dialog-updateidcard.vue?vue&type=template&id=cc275c98&"
import script from "./dialog-updateidcard.vue?vue&type=script&lang=js&"
export * from "./dialog-updateidcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports